module.exports = __webpack_public_path__ + "resources/rsfb-credit.png";